import React, { useState } from 'react';

import ReactPaginate from 'react-paginate';
import { useMutation, useQuery } from '@apollo/react-hooks';

import AppBar from '../../../../base/components/AppBar/AppBar';

import styles from './ImpactPostsListPage.module.css';
import { postActionPopups } from '../../helpers/constants';
import Popup from '../../../../campaigns/components/Popup';
import ImpactListAddEditPopup from './components/ImpactPostsListAddEditPopup/ImpactPostsListAddEditPopup';
import ImpactListRemovePopup from './components/ImpactPostsListRemovePopup/ImpactPostsListRemovePopup';
import ImpactListHeader from './components/ImpactPostsListHeader/ImpactPostsListHeader';
import ImpactPostsListRecordLoader from './components/ImpactPostsListRecordLoader/ImpactPostsListRecordLoader';
import ImpactPostsListRecord from './components/ImpactPostsListRecord/ImpactPostsListRecord';
import {
  CREATE_IMPACT_POST,
  GET_IMPACT_POSTS,
  REMOVE_IMPACT_POST,
  UPDATE_IMPACT_POST
} from '../../../../graphql/ImpactDashboard';
import validateImpactPostPopup from '../../helpers/validateImpactPostPopup';
// import SortingArrow from "./components/SortingArrow/SortingArrow";

const ImpactPostsListPage = props => {
  const { postsPerPage } = props;

  const [activePopup, setActivePopup] = useState(null);
  const [filtering, setFiltering] = useState({
    page: 0,
    search: ''
  });
  const [sorting] = useState(null); // setSorting

  /*
  const sortingOrder = {
    ASC: 'asc',
    DESC: 'desc'
  };
  */
  const sortingOptions = {
    startDate: 'startDate',
    endDate: 'endDate',
    touchpoints: 'touchpoints'
  };

  /*
  const updateSorting = sortingOption => {
    if (sorting && sorting[sortingOption]) {
      setSorting({
        [sortingOption]:
          sorting[sortingOption] === sortingOrder.DESC
            ? sortingOrder.ASC
            : sortingOrder.DESC
      });
    } else {
      setSorting({
        [sortingOption]: sortingOrder.DESC
      });
    }
  };
  */

  const postsVariables = {
    start: filtering.page * postsPerPage || 0,
    end: (filtering.page + 1) * postsPerPage || 0,
    search: filtering.search,
    ...(sorting ? { sorting } : {})
  };

  const {
    data: { getImpactPosts: { posts, totalCount } = {} } = {},
    refetch,
    loading: getAccountsLoading
  } = useQuery(GET_IMPACT_POSTS, {
    variables: postsVariables,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });
  const [createImpactPost, { loading: createLoading }] = useMutation(
    CREATE_IMPACT_POST
  );
  const [updateImpactPost, { loading: updateLoading }] = useMutation(
    UPDATE_IMPACT_POST
  );
  const [removeImpactPost, { loading: removeLoading }] = useMutation(
    REMOVE_IMPACT_POST
  );

  const submitLoading = createLoading || updateLoading || removeLoading;

  const refetchList = async () => {
    await refetch(postsVariables);
  };

  const validateAddEditPopupSave = internalPost => {
    let isValid = true;

    if (internalPost && internalPost.content) {
      const validation = validateImpactPostPopup(internalPost.content);

      if (validation !== null) {
        isValid = false;
      }
    } else {
      isValid = false;
    }

    return isValid;
  };

  return (
    <div>
      <AppBar {...props} />
      <div className={styles.container}>
        <ImpactListHeader
          title="Impacts Dashboard"
          onAddButtonLabel="Add impact post"
          onAddClick={() => setActivePopup({ type: postActionPopups.ADD })}
          search={filtering.search}
          onSearch={searchText =>
            setFiltering({ ...filtering, search: searchText.trim() })
          }
        />
        {getAccountsLoading ? <ImpactPostsListRecordLoader /> : null}
        {!getAccountsLoading ? (
          <table
            border="0"
            cellSpacing="0"
            cellPadding="0"
            className={styles.mainTable}
          >
            <thead>
              <tr>
                <th className={styles.headerRow}>Title</th>
                <th
                  className={`${styles.headerRow} ${
                    styles.touchpointsContainer
                  } ${
                    sorting && sorting[sortingOptions.touchpoints]
                      ? styles.activeSorting
                      : ''
                  }`}
                >
                  Post date
                </th>
                <th className={styles.headerRow} />
              </tr>
            </thead>
            <tbody>
              {posts && posts.length
                ? posts.map((cT, i) => (
                    <ImpactPostsListRecord
                      key={`record-item-${i.toString()}`}
                      post={cT}
                      setActivePopup={setActivePopup}
                    />
                  ))
                : null}
              {!posts || !posts.length ? (
                <tr className={styles.noResultsPlaceholder}>
                  <td colSpan="3">No results found</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        ) : null}
        {activePopup && activePopup.type === postActionPopups.ADD ? (
          <Popup
            component={
              <ImpactListAddEditPopup
                activePopup={activePopup}
                title="Add impact post"
                subtitle1="Subtitle 1"
                onSubmit={createImpactPost}
                onClose={() => setActivePopup(null)}
                submitLoading={submitLoading}
                setActivePopup={setActivePopup}
                refetchList={refetchList}
                validate={internalPost =>
                  validateAddEditPopupSave(internalPost)
                }
              />
            }
            customStyles={{ padding: 'none' }}
            onClose={() => {}}
          />
        ) : null}
        {activePopup && activePopup.type === postActionPopups.EDIT ? (
          <Popup
            component={
              <ImpactListAddEditPopup
                activePopup={activePopup}
                title="Edit impact post"
                onSubmit={updateImpactPost}
                onClose={() => setActivePopup(null)}
                setActivePopup={setActivePopup}
                refetchList={refetchList}
                submitLoading={submitLoading}
                validate={internalPost =>
                  validateAddEditPopupSave(internalPost)
                }
              />
            }
            customStyles={{ padding: 'none' }}
            onClose={() => {}}
          />
        ) : null}
        {activePopup && activePopup.type === postActionPopups.DELETE ? (
          <Popup
            component={
              <ImpactListRemovePopup
                activePopup={activePopup}
                title="Are you sure you want to delete Impact"
                subtitle1={`Are you sure you want to delete ${activePopup &&
                  activePopup.post &&
                  activePopup.post.title}?`}
                onSubmit={async postId => {
                  await removeImpactPost({
                    variables: { id: postId }
                  });
                  setActivePopup(null);
                  await refetch(postsVariables);
                }}
                onClose={() => setActivePopup(null)}
              />
            }
            customStyles={{ padding: 'none' }}
            onClose={() => {}}
          />
        ) : null}
        {postsPerPage && posts && posts.length ? (
          <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel="..."
            breakClassName="break-me"
            pageCount={Math.ceil(totalCount / postsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            initialPage={filtering.page}
            forcePage={filtering.page}
            disableInitialCallback
            onPageChange={pageNumber =>
              setFiltering({ ...filtering, page: pageNumber.selected })
            }
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
          />
        ) : null}
      </div>
    </div>
  );
};

export default ImpactPostsListPage;
